<template>
  <div class="shopsInfo container">
    <navBar :title="topTitle"/>
    <div class="infoBox">
      <div class="item flexBetween">
        <div class="left">微信号</div>
        <div class="right">
          <van-field v-model="wxName" placeholder="请输入微信号"/>
        </div>
      </div>
      <div class="item flexBetween">
        <div class="left">微信支付二维码</div>
        <div class="right">
          <!--          <van-button size="small" icon="photo" color="#687BFF">{{uploadText}}</van-button>-->
        </div>
      </div>
      <div class="uploadImg">
        <van-uploader v-model="fileList" :max-count="1" preview-size="327px" :after-read="afterRead" :max-size="510000" @delete="beforeDelete">
          <van-button size="small" icon="photo" color="#687BFF">开始上传二维码</van-button>
        </van-uploader>
      </div>

      <div class="sureBtn">
        <van-button color="#687BFF" @click="sureBtn" :disabled="isDisable">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import navBar from "../../../components/navBar";
  import Vue from 'vue';
  import {Uploader, Button, Field, Toast} from 'vant';

  Vue.use(Uploader).use(Button).use(Field).use(Toast);
  export default {
    name: "index",
    components: {
      navBar
    },
    data() {
      return {
        isDisable: false,
        wxName: '',//微信号
        topTitle: '设置',
        fileList: [],
        imgUpload: [], // 上传后台后返回图片
        img: '',
        isImgChange:false,//图片是否重新上传
      }
    },
    mounted(){
      this.getPartnerInfo();
    },
    methods: {
      //获取运营商信息
      getPartnerInfo(){
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/communityorder/getpartnerpayimg`,
          data: {}
        }).then(res=>{
          if(res.code==0){
            console.log(res)
            this.wxName = res.data.wechat;
            this.fileList.push({ url: res.data.pay_image,content:res.data.pay_image })
            console.log(this.fileList)
          }
        })

      },
      sureBtn() {
        let wechat = this.wxName;
        let imagesContent = this.fileList.length > 0 ? this.fileList[0].content : '';
        let images = this.isImgChange?JSON.stringify(this.imgUpload):'';

        if (wechat && imagesContent) {
          this.isDisable = true;
          if(this.isImgChange){
            this.sendHttp({
              method: 'post',
              url: `${this.orderUrl}/communityorder/partnerpayimg`,
              data: {
                images,
                wechat: wechat
              }
            }).then(res => {
              if (res.code == 0) {
                this.$router.push('/');
              }
              Toast(res.msg);
              this.isDisable = false;
            })
          }else{
            this.sendHttp({
              method: 'post',
              url: `${this.orderUrl}/communityorder/partnerpayimg`,
              data: {
                wechat: wechat
              }
            }).then(res => {
              if (res.code == 0) {
                this.$router.push('/');
              }
              Toast(res.msg);
              this.isDisable = false;
            })
          }

        } else {
          Toast('请将微信号和支付二维码填写完整');
        }

      },
      //清空imgUpload
      beforeDelete(){
        this.imgUpload = [];
      },
      // 图片上传完后的回调函数
      afterRead(file) {
        this.isImgChange = true;
        this.img = file.content;
        let fd = new FormData();
        fd.append('file', file.file);
        fd.append('ratio', '110x84,375x240');
        fd.append('rootPath', 'gg');

        fetch(`${this.$upImg}`, {
          method: 'POST',
          body: fd,
        }).then(res => {
          // fetch 第一次 只返回 headers
          if (res.ok) {
            // 第二次解析data.调用 res.json() 方法(返回的 res 身上有常用的有 5-6个方法，处理json 二进制 等等)
            res.json().then(data => {
              this.imgUpload.push(data);
              console.log(this.imgUpload)
            }, err => {
              console.log(err)
            })
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .right {
    .van-field__control {
      text-align: right !important;
    }
  }

  .sureBtn {
    display: flex;
    justify-content: center;

    .van-button--normal {
      width: 347px;
      height: 48px;
      line-height: 48px;
    }
  }

  .uploadImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 327px;
    height: 327px;
    margin: 20px auto;
    margin-bottom: 50px;
    background: #F5f5f5;
  }

  .infoBox {
    margin-top: 6px;
    padding: 0 14px;
    padding-bottom: 40px;
    background: #fff;

    .item {
      line-height: 44px;
      border-bottom: 1px solid #F5f5f5;

      .left {
        font-weight: bold;
      }

      .blue {
        color: #687BFF;
      }
    }
  }
</style>
<style lang="less">
  .right {
    .van-field__control {
      text-align: right;
      font-size: 14px;
      color: #333;
    }
  }
</style>
